module.exports = __webpack_public_path__ + "img/Billedbog_Barna.acd8b40c.jpg";